import React from 'react';

const DateFormatter = (dateStrOrParams) => {
  let dateStr;

  // Check if the input is a params object or a date string
  if (typeof dateStrOrParams === 'object' && dateStrOrParams?.value) {
    dateStr = dateStrOrParams?.value; // Extract value from params object
  } else {
    dateStr = dateStrOrParams; // Use the provided date string
  }

  if (!dateStr) return ''; // Handle empty or null values

  // Attempt to parse the date string
  const date = new Date(dateStr);

  // Check if the parsed date is valid
  if (isNaN(date.getTime())) {
    return ''; // Display error message for invalid dates
  }

  // Format the date using a custom format with leading zeros for single-digit days and months
  const formattedDate = `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;

  return formattedDate;
};

export default DateFormatter;
